export default "__VITE_ASSET__BuK1bxKN__"